export default __webpack_public_path__ + "static/media/icon-5.02d7d574.svg";